import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faCog } from '@fortawesome/free-solid-svg-icons';
import { Avatar, Dropdown, Button } from 'antd';
import styled from 'styled-components';

import { authAPI } from 'utils/portal-apis';
import { SignIn } from 'components/Auth';
import NotificationPopover from 'components/NotificationPopover';
import { getUserState } from 'stores';

// Re-export settings from separate file for Vite Fast Refresh compatibility
export { defaultSettings, publicDefaultSettings } from './settings';
export { getMenuRoutes } from './menuRoutes';

const StyledDropdown = styled(Dropdown)`
  &.live {
    cursor: default !important;
  }

  /* Add hover delay - only show dropdown after 3 seconds of hovering */
  &:not(.live) {
    .ant-dropdown-trigger {
      transition-delay: 3s;
    }
  }
`;

export function RightContent({ isPublicPage, showSignIn, signInSetter, isLive }) {
  try {
    const loggedInUser = getUserState().user || {};

    const isBroadcastPage =
      window.location.href.indexOf('/broadcast/') > 0 && window.location.href.indexOf('/broadcast/my') < 0;
    const actionSelect = ({ key }) => {
      if (key === 'logout') {
        authAPI
          .logout()
          .then(() => {
            window.location.href = '/auth/login';
          })
          .catch(error => {
            console.error('Logout failed:', error);
            window.location.href = '/auth/login';
          });
      }
    };

    if (authAPI.isLoggedIn()) {
      const profilePic =
        loggedInUser.profile_pic || 'https://hotmic-content.s3-us-west-1.amazonaws.com/users/default-profile.png';
      const userName = loggedInUser.name || 'User';

      const menuItems = [];

      if (isPublicPage !== true) {
        menuItems.push({
          key: 'settings',
          label: (
            <a href="/settings">
              <FontAwesomeIcon icon={faCog} className="anticon" fixedWidth /> Settings
            </a>
          ),
        });
      }

      if (isPublicPage !== true && !isBroadcastPage) {
        menuItems.push({ type: 'divider' });
      }

      if (!isBroadcastPage) {
        menuItems.push({
          key: 'logout',
          label: (
            <a href="/auth/login">
              <FontAwesomeIcon icon={faSignOutAlt} className="anticon" fixedWidth /> Logout
            </a>
          ),
        });
      }

      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', height: '64px' }}>
          {/* Notification Bell */}
          <NotificationPopover userId={loggedInUser._id} />

          {/* User Profile Dropdown */}
          <StyledDropdown
            menu={{ items: menuItems, onClick: actionSelect }}
            disabled={isLive}
            className={isLive ? 'live' : ''}
            trigger={['click']}
          >
            <span style={{ height: '64px', display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <Avatar src={profilePic} />
              <span style={{ margin: '0 10px' }}>{userName}</span>
            </span>
          </StyledDropdown>
        </div>
      );
    } else {
      return (
        <span>
          <Button
            type="primary"
            style={{ paddingLeft: 20, paddingRight: 20 }}
            onClick={() => (signInSetter ? signInSetter(true) : null)}
          >
            Sign In
          </Button>
          {showSignIn && (
            <SignIn showModal={showSignIn} onCancelled={() => (signInSetter ? signInSetter(false) : null)} />
          )}
        </span>
      );
    }
  } catch (error) {
    // Return a simple fallback
    return (
      <span>
        <Button type="primary" style={{ paddingLeft: 20, paddingRight: 20 }}>
          Menu
        </Button>
      </span>
    );
  }
}
